import React, { useEffect, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';


const TermsOfService = () => {
  const topRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleKnowMore = () => {
    navigate('/', { state: { scrollToEmail: true } });
  };

  return (
    <div
      className="min-h-screen paper-texture bg-fixed bg-primary-beige"
    >
      {/* Texture overlay removed globally */}

      {/* Shared Header Component */}
      <Header onInnerCircleClick={handleKnowMore} />

      {/* Scroll target */}
      <div ref={topRef} />

      {/* Content - Added top padding for fixed header */}
      <main className="relative z-10 pt-24 md:pt-28 pb-16 md:pb-24">
        {/* Full width title section */}
        <div className="w-full mb-12 flex flex-col items-center">
          <div className="w-full flex items-center justify-between gap-4 sm:gap-6">
            <div className="h-px bg-primary-sky-blue flex-grow" />
            <h1
              className="font-heading text-3xl md:text-5xl text-center px-4 shrink-0 text-primary-royal-blue"
            >
              Terms of Service
            </h1>
            <div className="h-px bg-primary-sky-blue flex-grow" />
          </div>
          <p className="mt-4 font-body text-sm text-primary-royal-blue/70">
            Last Updated: February 2026
          </p>
        </div>

        {/* Content Container */}
        <div className="max-w-3xl mx-auto px-6 py-8 md:px-12 md:py-12 space-y-8 bg-gradient-to-b from-white to-[#f5f5f5] shadow-2xl rounded-sm relative">

          {/* Golden top border accent */}
          <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-brand-gradient-gold-start to-brand-gradient-gold-end" />
          <section>
            <p className="font-body text-sm md:text-base leading-relaxed mb-6 text-primary-royal-blue">
              Welcome to ZURIAN. These Terms of Service ("Terms") govern your access to and use of the ZURIAN website and services ("Service"), including our Early Access Program. Please read these Terms carefully before using our Service.
            </p>
            <p className="font-body text-sm md:text-base leading-relaxed text-primary-royal-blue">
              By accessing or using the Service, you agree to be bound by these Terms. If you disagree with any part of the terms, then you may not access the Service.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-xl mb-4 text-primary-royal-blue">
              1. Early Access Program & Benefits
            </h2>
            <p className="font-body text-sm md:text-base leading-relaxed mb-4 text-primary-royal-blue">
              By registering for our Early Access Program, you may be eligible for certain exclusive benefits. These benefits are subject to the following conditions:
            </p>
            <ul className="font-body text-sm md:text-base leading-relaxed space-y-3 ml-6 list-disc text-primary-royal-blue">
              <li>
                <strong>Launch Discounts & Coupon Codes:</strong> Any promotional codes or discounts provided to Early Access members are valid for a limited time as specified at issuance. They are non-transferable, cannot be redeemed for cash, and may be subject to minimum purchase requirements. ZURIAN reserves the right to modify or cancel these offers at any time.
              </li>
              <li>
                <strong>Newsletter & Communications:</strong> By signing up, you consent to receive marketing emails, newsletters, and updates regarding our launch. You may opt out of these communications at any time via the "Unsubscribe" link in our emails, though you may miss out on time-sensitive offers.
              </li>
              <li>
                <strong>Inner Circle Community:</strong> Access to any private community channels (e.g., Discord, WhatsApp, or exclusive events) is a privilege, not a right. Members must adhere to our community guidelines. ZURIAN reserves the right to revoke community access for any participant who violates our standards of conduct or policies.
              </li>
            </ul>
          </section>

          <section>
            <h2 className="font-heading text-xl mb-4 text-primary-royal-blue">
              2. Intellectual Property
            </h2>
            <p className="font-body text-sm md:text-base leading-relaxed text-primary-royal-blue">
              The Service and its original content, features, and functionality are and will remain the exclusive property of ZURIAN INTERNATIONAL PRIVATE LIMITED and its licensors. The Service is protected by copyright, trademark, and other laws of both India and foreign countries. Our trademarks and trade dress may not be used in connection with any product or service without the prior written consent of ZURIAN.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-xl mb-4 text-primary-royal-blue">
              3. User Conduct
            </h2>
            <p className="font-body text-sm md:text-base leading-relaxed mb-4 text-primary-royal-blue">
              You agree not to use the Service:
            </p>
            <ul className="font-body text-sm md:text-base leading-relaxed space-y-2 ml-6 text-primary-royal-blue">
              <li>• In any way that violates any applicable national or international law or regulation.</li>
              <li>• To transmit, or procure the sending of, any advertising or promotional material, including any "junk mail", "chain letter," "spam," or any other similar solicitation.</li>
              <li>• To impersonate or attempt to impersonate ZURIAN, a ZURIAN employee, another user, or any other person or entity.</li>
            </ul>
          </section>

          <section>
            <h2 className="font-heading text-xl mb-4 text-primary-royal-blue">
              4. Limitation of Liability
            </h2>
            <p className="font-body text-sm md:text-base leading-relaxed text-primary-royal-blue">
              In no event shall ZURIAN, nor its directors, employees, partners, agents, suppliers, or affiliates, be liable for any indirect, incidental, special, consequential or punitive damages, including without limitation, loss of profits, data, use, goodwill, or other intangible losses, resulting from your access to or use of or inability to access or use the Service.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-xl mb-4 text-primary-royal-blue">
              5. Changes to Terms
            </h2>
            <p className="font-body text-sm md:text-base leading-relaxed text-primary-royal-blue">
              We reserve the right, at our sole discretion, to modify or replace these Terms at any time. If a revision is material, we will try to provide at least 30 days' notice prior to any new terms taking effect. What constitutes a material change will be determined at our sole discretion.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-xl mb-4 text-primary-royal-blue">
              6. Contact Us
            </h2>
            <p className="font-body text-sm md:text-base leading-relaxed text-primary-royal-blue">
              If you have any questions about these Terms, please contact us at:
              <br /><br />
              <strong>Email:</strong> <a href="mailto:care@zurian.co.in" className="hover:underline">care@zurian.co.in</a>
              <br />
              <strong>Company:</strong> ZURIAN INTERNATIONAL PRIVATE LIMITED
            </p>
          </section>
        </div>
      </main>

      {/* Footer */}
      {/* Footer */}
      <Footer />
    </div>
  );
};

export default TermsOfService;
